import { Injectable } from '@angular/core';
import { Urls } from '@core/config';
import { BaseApiService } from '@smartera/core';

@Injectable({
	providedIn: 'root',
})
export class ElasticsearchDataSyncHistoryService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/elasticsearch-data-collector/synchronization/logs`;
	}
}
